// extracted by mini-css-extract-plugin
export default {"descriptionIntro":"styles_descriptionIntro__IlZw5"};